import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { formatConfigTimeToTime } from '../../../libs/dateUtilities';
import { getNumberOfDaysBreakPoint, getStyleForShiftId } from '../../../libs/calendarConfig';
import SmallSemiTruckIcon from '../../../images/calendar/smallSemiTruckIcon.js';

import clsx from 'classnames';
import _ from 'lodash';
import ShiftFlags from './ShiftFlags';
import { statuses } from '../WorkDayStatuses.js';

const atLocationLookup = {};
statuses.forEach(({ value, isAtLocation, shortDisplay }) => {
	if (isAtLocation) {
		atLocationLookup[value] = shortDisplay;
	}
});

function styles() {
	return {
		container: {
			zIndex: 1,
			position: 'absolute',
			left: 0,
			right: 0,
			top: 0,
			bottom: 0,
			margin: 3,
			height: 'auto',

			borderRadius: 1,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',

			textAlign: 'center',

			//- Overload
			//backgroundColor : '#FFF',
			color: '#666',
			fontSize: 16,
		},
		containerForDriverRoom: {
			margin: 0,
			fontSize: '100%',
		},
		nodIsMediumContainer: {
			fontSize: 15,
		},
		nodIsLargeContainer: {
			fontSize: 12,
		},
		noCallNoShowContainer: {
			textTransform: 'uppercase',
			fontWeight: 500,
			backgroundColor: '#FFEBEE',
			color: '#C62828',
			border: '1px solid #FFCDD2',
		},

		callOutContainer: {
			fontWeight: 500,
			backgroundColor: '#EFEBE9',
			color: '#A1887F',
		},

		absentContainer: {
			textTransform: 'uppercase',
			fontWeight: 500,
			//backgroundColor: '#E0F2F1',
			//color: '#00695C',
			color: '#AAA',
			//border : '1px solid #B2DFDB',
		},
		cancelledEdContainer: {
			textTransform: 'uppercase',
			fontWeight: 500,
			backgroundColor: '#F2E5F5',
			color: '#9C27B0',
			border: '1px solid #E1BEE7',
		},
		ptoContainer: {
			fontWeight: 500,
			backgroundColor: '#E8EAF6',
			color: '#7986CB',
		},

		fmlaContainer: {
			fontWeight: 500,
			backgroundColor: '#E0F2F1',
			color: '#26A69A',
		},
		wcContainer: {
			fontWeight: 500,
			backgroundColor: '#E0F2F1',
			color: '#26A69A',
		},
		loaContainer: {
			fontWeight: 500,
			backgroundColor: '#E0F2F1',
			color: '#26A69A',
		},

		dayOffContainer: {
			color: '#aaa',
			fontWeight: 500,
		},

		notScheduledContainer: {
			color: '#888',
			//backgroundColor : `rgba(40,40,40,.05)`,
			fontWeight: 400,
			background: `repeating-linear-gradient(
				45deg,
				#FAFAFA,
				#FAFAFA 10px,
				#ECEFF1 10px,
				#ECEFF1 20px
			);`,
		},
		workingContainer: {
			position: 'relative',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			backgroundColor: '#665', //-overridden
			color: '#fff', //- overridden
			fontWeight: 500,
			padding: `11px 7px`,
			//fontSize : `106.66666667%`,
		},
		workingContainerForDriverRoom: {
			padding: `10px 4px`,
		},
		workingContainerForDriverRoomCompact: {
			padding: `2px 4px`,
		},
		dayOffForDriverRoom: {
			fontSize: '80%',
			opacity: '.8',
		},
		missingStatusContainer: {
			textTransform: 'uppercase',
			fontWeight: 500,
			backgroundColor: '#FFCCBC',
			color: '#E64A19',
		},
		shiftTruckContainer: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'left',
			alignItems: 'center',
		},
		shiftStart: {
			marginRight: 6,
			borderRight: '1px solid rgba(255,255,255,.7)',
			paddingRight: 6,
		},
		open: {
			fontWeight: 500,
		},
		openVertical: {
			fontWeight: 500,
			writingMode: 'vertical-rl',
			textOrientation: 'mixed',
			marginTop: -5,
			marginRight: -5,
			marginBottom: -5,
			fontSize: 10,
		},
		whiteSemiTruckIcon: {
			display: 'inline-block',
			width: 15,
			height: 15,
			verticalAlign: 'middle',
			marginRight: 5,
			marginLeft: 0,
		},
		truckInfo: {
			display: 'flex',
			fontWeight: 600,
			alignItems: 'center',
		},
		shiftTimeForDriverRoom: {
			display: 'flex',
			fontWeight: 600,
			alignItems: 'center',
			fontSize: '115%',
		},
		markerTop: {
			position: 'absolute',
			top: 0,
			left: 0,
			borderColor: 'transparent',
			borderStyle: 'solid',
		},
		markerBottom: {
			position: 'absolute',
			top: 0,
			left: 0,
			borderColor: 'transparent',
			borderStyle: 'solid',
			borderRadius: '1px',
		},
		noteTop: {
			borderWidth: '7.5px',
			borderLeftColor: '#fff',
			borderTopColor: '#fff',
			zIndex: 4,
		},
		noteBottom: {
			borderWidth: '7px',
			borderLeftColor: '#26C6DA',
			borderTopColor: '#00BCD4',
			zIndex: 4,
		},
		overrideTop: {
			top: 'auto',
			bottom: 0,
			borderWidth: '7.5px',
			borderLeftColor: '#fff',
			borderBottomColor: '#fff',
		},
		overrideBottom: {
			top: 'auto',
			bottom: 0,
			borderWidth: '7px',
			borderLeftColor: '#AB47BC',
			borderBottomColor: '#9C27B0',
		},
		stackedLines: {
			fontSize: '86.66666%',
			lineHeight: 0.9,
		},
		fromOtherTerminal: {
			display: 'flex',
			flexDirection: 'column',
			position: 'absolute',
			bottom: 0,
			margin: 1,
			zIndex: 5,
			fontSize: 12,
			fontWeight: 500,
			textTransform: 'uppercase',
			textAlign: 'left',
			paddingLeft: 10,
			left: 0,
			paddingBottom: 2,
		},
		fromOtherTerminalNodIsMedium: {
			fontSize: 10,
		},
		fromOtherTerminalNodIsLarge: {
			fontSize: 8,
		},
		fromOtherTerminalForDriverRoom: {
			fontSize: '80%',
			textAlign: 'right',
			right: 15,
		},
	};
}

class WorkDay extends Component {
	render() {
		const {
			numberOfDays,
			classes,
			workDay,
			locationMap,
			//	assignedLocationId,
			isDriverRoom,
			isOdd,
			userRowCount,
		} = this.props;

		const { nodIsMedium, nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);

		const {
			workDayId,
			status,
			shiftId,
			notes,
			overrides,
			isLate,
			// locationId,
			workingAtLocationId,
		} = workDay;

		let hasNotes = !_.isEmpty(notes);
		let hasOverrides = !_.isEmpty(overrides);

		let containerClassnames = [classes.container];
		if (isDriverRoom) {
			containerClassnames.push(classes.containerForDriverRoom);
		}

		let content;
		let shiftStyle = {};
		if (
			status === 'working' ||
			status === 'extraDay' ||
			status === 'swapOn' ||
			status === 'modifiedDay' ||
			atLocationLookup[status]
		) {
			containerClassnames.push(classes.workingContainer);
			if (isDriverRoom) {
				if (userRowCount >= 20) {
					containerClassnames.push(classes.workingContainerForDriverRoomCompact);
				} else {
					containerClassnames.push(classes.workingContainerForDriverRoom);
				}
			}

			content = this.renderWorking();
			shiftStyle = getStyleForShiftId({
				shiftId,
				status: 'working',
				isOdd,
			});
		} else if (status === 'dayOff') {
			containerClassnames.push(classes.dayOffContainer);
			content = this.renderDayOff();
		} else if (status === 'swapOff') {
			containerClassnames.push(classes.swapOffContainer);
			content = this.renderSwapOff();
		} else if (status === 'absent') {
			containerClassnames.push(classes.absentContainer);
			content = this.renderAbsent();
		} else if (status === 'cancelledEd') {
			containerClassnames.push(classes.cancelledEdContainer);
			content = this.renderCancelledEd();
		} else if (status === 'noCallNoShow') {
			containerClassnames.push(classes.noCallNoShowContainer);
			content = this.renderNoCallNoShow();
		} else if (status === 'callOut') {
			containerClassnames.push(classes.callOutContainer);
			content = this.renderCallOut();
		} else if (status === 'notScheduled') {
			containerClassnames.push(classes.notScheduledContainer);
			content = this.renderNotScheduled();
		} else if (status === 'pto') {
			containerClassnames.push(classes.ptoContainer);
			content = this.renderPto();
		} else if (status === 'fmla') {
			containerClassnames.push(classes.fmlaContainer);
			content = this.renderFmla();
		} else if (status === 'wc') {
			containerClassnames.push(classes.wcContainer);
			content = this.renderWc();
		} else if (status === 'loa') {
			containerClassnames.push(classes.loaContainer);
			content = this.renderLoa();
		} else {
			containerClassnames.push(classes.missingStatusContainer);
			content = this.renderMissing();
		}

		if (nodIsLarge) {
			containerClassnames.push(classes.nodIsLargeContainer);
		} else if (nodIsMedium) {
			containerClassnames.push(classes.nodIsMediumContainer);
		}

		let showOtherLocation = false;

		let formOtherLocationDisplay = null;
		let fromOtherExtraClass = null;
		if (workingAtLocationId) {
			showOtherLocation = true;
			const location = locationMap[workingAtLocationId] || {
				display: 'missing',
			};
			formOtherLocationDisplay = location.display;
			if (nodIsLarge) {
				fromOtherExtraClass = classes.fromOtherTerminalNodIsLarge;
				formOtherLocationDisplay = formOtherLocationDisplay.substring(0, 4);
			} else if (nodIsMedium) {
				fromOtherExtraClass = classes.fromOtherTerminalNodIsMedium;
				formOtherLocationDisplay = formOtherLocationDisplay.substring(0, 10);
			}
		}

		// Instead lets have the workday figure ou they are are a new location
		/*
		if (assignedLocationId !== locationId) {
			showOtherLocation = true;
			const location = locationMap[locationId] || { display: 'missing' };
			formOtherLocationDisplay = location.display;
			if (nodIsLarge) {
				fromOtherExtraClass = classes.fromOtherTerminalNodIsLarge;
				formOtherLocationDisplay = formOtherLocationDisplay.substring(0, 4);
			} else if (nodIsMedium) {
				fromOtherExtraClass = classes.fromOtherTerminalNodIsMedium;
				formOtherLocationDisplay = formOtherLocationDisplay.substring(0, 10);
			}

			if (isDriverRoom) {
				fromOtherExtraClass = classes.fromOtherTerminalForDriverRoom;
			}
		}
		*/

		if (isDriverRoom) {
			hasNotes = false;
			hasOverrides = false;
		}

		return (
			<div key={workDayId} className={clsx(containerClassnames)} style={shiftStyle}>
				{content}

				{hasNotes && (
					<Fragment>
						<div className={clsx(classes.markerTop, classes.noteTop)} />
						<div className={clsx(classes.markerBottom, classes.noteBottom)} />
					</Fragment>
				)}

				{hasOverrides && (
					<Fragment>
						<div className={clsx(classes.markerTop, classes.overrideTop)} />
						<div className={clsx(classes.markerBottom, classes.overrideBottom)} />
					</Fragment>
				)}

				{showOtherLocation && (
					<div className={clsx(classes.fromOtherTerminal, fromOtherExtraClass)}>
						{formOtherLocationDisplay}
					</div>
				)}

				<ShiftFlags numberOfDays={numberOfDays} workDayStatus={status} isLate={isLate} />
			</div>
		);
	}

	renderWorking = () => {
		const {
			numberOfDays,
			classes,
			workDay,
			//userMap,
			isOpen,
			assignedLocationId,
			isDriverRoom,
		} = this.props;

		const { nodIsSmall, nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);

		const { shiftId, shiftTime, locationId, userFromLocationId } = workDay;

		//const user = userMap[userId] || { firstName: '', lastName: 'missing' };
		const style = getStyleForShiftId({ shiftId, status: 'working' });

		//- For a ton of days don't show the truck or the driver
		let time = '';
		if (!nodIsLarge) {
			//time = <div className={classes.shiftStart}>{formatConfigTimeToTime(shiftTime)}</div>;
		}

		let details = '';
		details = (
			<div className={classes.truckInfo}>
				{nodIsSmall && (
					<SmallSemiTruckIcon fill={style.color} className={classes.whiteSemiTruckIcon} />
				)}
				<div>{formatConfigTimeToTime(shiftTime)}</div>
			</div>
		);

		if (isDriverRoom) {
			details = (
				<div className={classes.shiftTimeForDriverRoom}>{formatConfigTimeToTime(shiftTime)}</div>
			);
		}

		const extraStyle =
			userFromLocationId || assignedLocationId !== locationId
				? { position: 'relative', top: nodIsLarge ? -2 : -5 }
				: {};

		return (
			<Fragment>
				<div className={classes.shiftTruckContainer} style={extraStyle}>
					{time}
					{details}
				</div>
				{isOpen && !nodIsLarge && <div className={classes.openVertical}>OPEN</div>}
			</Fragment>
		);
	};

	renderNoCallNoShow = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>NC/NS</span>;
		} else if (nodIsMedium) {
			return (
				<span>
					<div>NO CALL</div>
					<div style={{ fontSize: '70%' }}>NO SHOW</div>
				</span>
			);
		} else {
			return <span>NO CALL / NO SHOW</span>;
		}
	};

	renderCallOut = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>Call Out</span>;
		} else if (nodIsMedium) {
			return <span>Call Out</span>;
		} else {
			return <span>Call out</span>;
		}
	};

	renderPto = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>PTO</span>;
		} else if (nodIsMedium) {
			return (
				<span>
					<div>PTO</div>
				</span>
			);
		} else {
			return <span>PTO</span>;
		}
	};

	renderFmla = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>FMLA</span>;
		} else if (nodIsMedium) {
			return (
				<span>
					<div>FMLA</div>
				</span>
			);
		} else {
			return <span>FMLA</span>;
		}
	};

	renderWc = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>WC</span>;
		} else if (nodIsMedium) {
			return (
				<span>
					<div>WC</div>
				</span>
			);
		} else {
			return <span>WC</span>;
		}
	};

	renderLoa = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);

		if (nodIsLarge) {
			return <span>LOA</span>;
		} else if (nodIsMedium) {
			return (
				<span>
					<div>LOA</div>
				</span>
			);
		} else {
			return <span>LOA</span>;
		}
	};

	renderCancelledEd = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge, nodIsMedium } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return (
				<span role={'img'} aria-label="cancel">
					🚫 ED
				</span>
			);
		} else if (nodIsMedium) {
			return (
				<span>
					<div>ED</div>
					<div style={{ fontSize: '70%' }}>CANCELLED</div>
				</span>
			);
		} else {
			return <span>ED CANCELLED</span>;
		}
	};

	renderNotScheduled = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>N/A</span>;
		} else {
			return <span>N/A</span>;
		}
	};

	renderDayOff = () => {
		const { isDriverRoom, numberOfDays, classes } = this.props;
		const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
		if (isDriverRoom) {
			return <span className={classes.dayOffForDriverRoom}>OFF</span>;
		} else if (nodIsLarge) {
			return <span>OFF</span>;
		} else {
			return <span>OFF</span>;
		}
	};
	renderSwapOff = () => {
		const { isDriverRoom, numberOfDays, classes } = this.props;
		const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
		if (isDriverRoom) {
			return <span className={classes.swapOffForDriverRoom}>SWAP OFF</span>;
		} else if (nodIsLarge) {
			return <span>SWAP OFF</span>;
		} else {
			return <span>SWAP OFF</span>;
		}
	};
	renderAbsent = () => {
		const { numberOfDays } = this.props;
		const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>OFF</span>;
		} else {
			return <span>OFF</span>;
		}
	};
	renderMissing = () => {
		const { workDay, numberOfDays } = this.props;
		const { nodIsLarge } = getNumberOfDaysBreakPoint(numberOfDays);
		if (nodIsLarge) {
			return <span>{workDay.status}</span>;
		} else {
			return <span>{workDay.status}</span>;
		}
	};
}
WorkDay.propTypes = {
	numberOfDays: PropTypes.number,
	classes: PropTypes.object,
	workDay: PropTypes.object,
	userMap: PropTypes.object,
	isDriverRoom: PropTypes.bool,
};
WorkDay.defaultProps = {};
export default withStyles(styles)(WorkDay);
